import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }

import { reactive, onMounted } from 'vue'
  import api from '@/api/index'
  import citydata from '@/assets/js/citydata'
  import { ElMessage, ElLoading } from 'element-plus'
  import {useRouter} from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Add',
  setup(__props) {

  const router = useRouter()
  const baseData:any = reactive({
    citydata : [],
    wlnlist : [],
    wlncompanylist : [],
    wlnshoplist : [],
  })
  const props = {
    expandTrigger: 'hover',
    children: 'cityArr',
    label: 'Name',
    value: 'Code',
  }
  const form = reactive({
    wlnid:'',
    companyid:'',
    wlnshopname:'',
    TjiaCode:'',
    company: '',
    password: '',
    repassword: '',
    name: '',
    mobile: '',
    email: '',
    TIN: '',
    address: '',
    bankAccount: '',
    bank: '',
    areas: [],
    province: '',
    city: '',
    area: '',
  })
  const changeAreas = () => {
    form.province = form.areas[0]
    form.city = form.areas[1]
    form.area = form.areas[2]
  }
  const onSubmit = () => {
    const loading = ElLoading.service({lock: true})
    if(!form.wlnid){
      ElMessage.error('请选择合适的服务商')
      loading.close()
      return false
    }
    if(!form.wlnshopname){
      ElMessage.error('请选择合适的商铺')
      loading.close()
      return false
    }
    api.supplierApi.save(form).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        router.push("/supplier");
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const goBack = () => {
    router.go(-1);
  }
  const getWlnList = () => {
    const loading = ElLoading.service({lock: true})
    api.supplierApi.getWlnList({}).then((res:any)=>{
      if(res.code==200){
        baseData.wlnlist = res.data
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const getWlnShopList = () => {
    const loading = ElLoading.service({lock: true})
    api.supplierApi.getWlnShopList({}).then((res:any)=>{
      if(res.code==200){
        baseData.wlnshoplist = res.data.data
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  const getCompanyList = () => {
    const loading = ElLoading.service({lock: true})
    api.supplierApi.getCompanyList({}).then((res:any)=>{
      if(res.code==200){
        baseData.wlncompanylist = res.data
      }else{
        ElMessage.error(res.message)
      }
      loading.close()
    })
  }
  onMounted(() => {
    baseData.citydata = citydata.provinceArr
    getWlnList()
    getWlnShopList()
    getCompanyList()
  })
  
return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_breadcrumb, {
          class: "breadcrumb",
          separator: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/supplier' } }, {
              default: _withCtx(() => [
                _createTextVNode("服务商列表")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("添加服务商")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "180px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "万里牛账号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  modelValue: form.wlnid,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.wlnid) = $event)),
                  placeholder: "请选择合适的服务商",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.wlnlist, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.supplier_uid,
                        label: item.supplier_name,
                        value: item.supplier_uid
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  style: {"margin-left":"20px"},
                  type: "primary",
                  onClick: getWlnList
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("刷新服务商列表")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "快递公司账号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  modelValue: form.companyid,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.companyid) = $event)),
                  placeholder: "请选择合适的快递公司账号",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.wlncompanylist, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.distr_code,
                        label: item.distr_name,
                        value: item.distr_code
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  style: {"margin-left":"20px"},
                  type: "primary",
                  onClick: getCompanyList
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("刷新快递公司列表")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "万里牛商铺" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  modelValue: form.wlnshopname,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.wlnshopname) = $event)),
                  placeholder: "请选择合适的商铺",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.wlnshoplist, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.shop_name,
                        label: item.shop_name,
                        value: item.shop_name
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  style: {"margin-left":"20px"},
                  type: "primary",
                  onClick: getWlnShopList
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("刷新商铺列表")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "T+往来单位编号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.TjiaCode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.TjiaCode) = $event)),
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "公司名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.company,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.company) = $event)),
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.password,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.password) = $event)),
                  placeholder: "无需更改，请勿填写",
                  maxlength: "100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "重复密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.repassword,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.repassword) = $event)),
                  placeholder: "无需更改，请勿填写",
                  maxlength: "100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "联系人" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.name) = $event)),
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "手机号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.mobile,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.mobile) = $event)),
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "邮箱" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.email,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.email) = $event)),
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "纳税人识别号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.TIN,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.TIN) = $event)),
                  maxlength: "100",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "公司所在地" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.address,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.address) = $event)),
                  maxlength: "250",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "银行账户" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.bankAccount,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.bankAccount) = $event)),
                  maxlength: "250",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "开户行" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.bank,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.bank) = $event)),
                  maxlength: "250",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "地区" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: form.areas,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.areas) = $event)),
                  filterable: "",
                  options: baseData.citydata,
                  props: props,
                  onChange: changeAreas
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: goBack }, {
                  default: _withCtx(() => [
                    _createTextVNode("返回")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})